export default {
  getRoute: state => state.route,

  getSellersOptions: state => state.sellersOptions,
  getFormatedSellersOptions: (state, getters) => sellers =>
    sellers.map(seller => getters.getFormatedOption(seller)),

  getUsersOptions: state => state.usersOptions,
  getFormatedUsersOptions: (state, getters) => users =>
    users.map(user => getters.getFormatedOption(user)),

  getFormatedOption:
    () =>
      ({ name, uuid }) => ({ value: uuid, text: name }),
}
